/* Copyright 2015 Bloomberg Finance L.P.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { LinearScaleModel } from './LinearScaleModel';
export class LogScaleModel extends LinearScaleModel {
    constructor() {
        super(...arguments);
        this.type = 'log';
        this.globalMin = Number.MIN_VALUE;
        this.globalMax = Number.POSITIVE_INFINITY;
    }
    defaults() {
        return Object.assign(Object.assign({}, super.defaults()), { _model_name: 'LogScaleModel', _view_name: 'LogScale', domain: [] });
    }
}
//# sourceMappingURL=LogScaleModel.js.map